import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6 max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Czy lek o który Pan(i) wnioskuje był dotychczas stosowany? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "radio-group" }
const _hoisted_4 = { class: "radio-button form-radio-button" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_6 = { class: "radio-button form-radio-button" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = { class: "error-message" }

import { useField } from 'vee-validate';
import HasDrugAllergiesField from './HasDrugAllergiesField.vue';


export default {
  __name: 'DrugWasField',
  setup(__props) {

const { value, errorMessage } = useField('drugWasUsed');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            name: "drugWasUsed",
            value: "yes",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
            type: "radio"
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_5,
          _createTextVNode(" Tak ")
        ]),
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            name: "drugWasUsed",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null)),
            value: "no",
            type: "radio"
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_7,
          _createTextVNode(" Nie ")
        ])
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1)
    ]),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createBlock(HasDrugAllergiesField, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}